// src/utils/imageLoader.js

// ✅ Helper: import all images from a Webpack context
const importAllImages = (r) =>
  r.keys().map((key) => ({
    name: key.replace('./', '').replace(/\.\w+$/, '').toLowerCase(),
    src: r(key),
  }));

// ✅ Load passport-style image and apply rounded corners
export const loadImageAsDataURL = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const width = 200;
      const height = 300;
      const radius = 30;

      canvas.width = width;
      canvas.height = height;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(radius, 0);
      ctx.lineTo(width - radius, 0);
      ctx.quadraticCurveTo(width, 0, width, radius);
      ctx.lineTo(width, height - radius);
      ctx.quadraticCurveTo(width, height, width - radius, height);
      ctx.lineTo(radius, height);
      ctx.quadraticCurveTo(0, height, 0, height - radius);
      ctx.lineTo(0, radius);
      ctx.quadraticCurveTo(0, 0, radius, 0);
      ctx.closePath();
      ctx.clip();

      ctx.drawImage(img, 0, 0, width, height);
      ctx.restore();

      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
};

// ✅ Load any image from public/images/
export const loadImageFromPublic = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/jpeg'));
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });
};

// ✅ Load all passport images dynamically from multiple subfolders
export const getPassportImagePaths = () => {
  const loadedImages = [
    ...importAllImages(require.context('../images/1', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/2', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/3', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/4', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/5', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/6', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/7', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/8', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/9', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/10', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/nursery', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/lkg', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/ukg', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/inter', true, /\.(png|jpe?g)$/)),
    ...importAllImages(require.context('../images/students', true, /\.(png|jpe?g)$/)),
  ];

  // ✅ Remove duplicates safely
  const uniqueImages = Array.from(
    new Map(loadedImages.map((img) => [img.name, img])).values()
  );

  return uniqueImages;
};
